import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import "./App.css";
import Nav from "./Nav/Nav";
import HomeContent from "./HomeContent/HomeContent";
import About from "./About/About";
import Shop from "./Shop/Shop";
import Radio from "./Radio/Radio";
import ArtistSpotlightList from "./ArtistSpotlight/ArtistSpotlight";
import ArtistDetail from "./ArtistSpotlight/pages/ArtistDetail";
import { PlaylistsPage, PlaylistPage } from "./PlaylistPage/PlaylistPage";
import Discover from "./Discover/Discover";
import DiscoverLanding from "./Discover/DiscoverLanding";
import DiscoverZineStrip from "./Discover/DiscoverZineStrip";
// import SoundCloudPlayer from "./SoundCloudPlayer/SoundCloudPlayer";
import IOSApp from "./IOSApp/IOSApp";
import Welcome from "./Welcome/Welcome";
import AuthConfirm from "./AuthConfirm/AuthConfirm";
import { AudioPlayerProvider } from "./contexts/AudioPlayerContext";
import { CartProvider } from "./contexts/CartContext";
import Cart from "./components/Cart/Cart";
import products from "./data/products";


const HOME_TITLE = "Spinnin' Beans — Digital Crate Digging";

function getPageTitle(pathname) {
  if (pathname === "/") return HOME_TITLE;
  if (pathname === "/about") return "About · Spinnin' Beans";
  if (pathname.startsWith("/shop")) return "Shop · Spinnin' Beans";
  if (pathname === "/discover/search") return "Search · Spinnin' Beans";
  if (pathname.startsWith("/discover") || pathname.startsWith("/moments")) return "Discover · Spinnin' Beans";
  if (pathname.startsWith("/radio")) return "Radio · Spinnin' Beans";
  if (pathname.startsWith("/dig")) return "DIG · Spinnin' Beans";
  if (pathname.startsWith("/auth")) return "Confirming Email · Spinnin' Beans";
  if (pathname.startsWith("/welcome")) return "Welcome · Spinnin' Beans";
  if (pathname.startsWith("/playlist")) return "Playlists · Spinnin' Beans";
  if (pathname.startsWith("/artists")) return "Artist Spotlight · Spinnin' Beans";
  return HOME_TITLE;
}

const AnimatedRoutes = ({ setIsPDP, products, isPDP }) => {
  const location = useLocation();
  useEffect(() => {
    const isProductRoute = location.pathname.includes('/product/');
    setIsPDP(isProductRoute);
  }, [location, setIsPDP]);
  useEffect(() => {
    document.title = getPageTitle(location.pathname);
  }, [location.pathname]);
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ filter: "blur(8px)", opacity: 0 }}
        animate={{ filter: "blur(0px)", opacity: 1 }}
        exit={{ filter: "blur(8px)", opacity: 0 }}
        transition={{ duration: 0.3 }}
        style={{ height: "100%" }}
      >
        <Routes location={location}>
          <Route path="/" element={<HomeContent />} />
          <Route path="/about" element={<About />} />
          <Route path="/shop/*" element={<Shop setIsPDP={setIsPDP} isPDP={isPDP} products={products} />} />
          <Route path="/moments/:id/similar" element={<DiscoverLanding />} />
          <Route path="/discover/search" element={<Discover />} />
          <Route path="/discover/:id" element={<DiscoverLanding />} />
          <Route path="/discover" element={<DiscoverZineStrip />} />
          <Route path="/radio" element={<Radio />} />
          <Route path="/dig" element={<IOSApp />} />
          <Route path="/auth/confirm" element={<AuthConfirm />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/playlists" element={<PlaylistsPage />} />
          <Route path="/playlist/:name" element={<PlaylistPage />} />
          <Route path="/artistspotlight" element={<ArtistSpotlightList />} />
          <Route path="/artists/:artistId" element={<ArtistDetail />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
};


function App() {
  const [isPDP, setIsPDP] = useState(false);



  useEffect(() => {
    if (isPDP) {
      document.body.classList.add('pdp-open');
    } else {
      document.body.classList.remove('pdp-open');
    }
  }, [isPDP]);
  return (
    <AudioPlayerProvider>
      <CartProvider>
        <iframe
          id="soundcloud-iframe"
          title="Spinnin Beans SoundCloud Player"
          width="100%"
          height="166"
          scrolling="no"
          frameBorder="no"
          allow="autoplay"
          src="https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/xxwavyxx/sets/gang-coolin&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
          style={{ display: "none" }}
        ></iframe>
        {/* <SoundCloudPlayer /> */}
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <div className="App">
            <Nav />
            <Cart />
            <main className="App-content">
              <AnimatedRoutes setIsPDP={setIsPDP} isPDP={isPDP} products={products} />
            </main>
            {!isPDP && (
              <footer className="shop-footer">
                <p>&copy; {new Date().getFullYear()} Spinnin' Beans. All rights reserved.</p>
              </footer>
            )}
          </div>
        </Router>
      </CartProvider>
    </AudioPlayerProvider>
  );
}

export default App;
